// In-app 404 (handoff 7.5). Real content, not a server 500 / blank.

import { useNavigate } from 'react-router-dom';
import { AppBar } from '../components/AppBar';
import { BrandMark } from '../components/BrandMark';
import { motion } from 'motion/react';
import { useScreenEnter } from '../lib/motion';
import { getSession } from '../lib/session';

export function NotFound() {
  const navigate = useNavigate();
  const canList = !!getSession();
  return (
    <>
      <AppBar title="页面未找到" />
      <main className="app-main">
        <motion.section
          className="section"
          {...useScreenEnter()}
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '1rem' }}
        >
          <BrandMark size={32} className="text-accent" />
          <h1 style={{ fontSize: '1.5rem', fontWeight: 600, letterSpacing: '-0.01em' }}>页面未找到</h1>
          <p className="muted prose-measure">这个链接不存在或已失效。</p>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => navigate(canList ? '/list' : '/', { replace: true })}
          >
            {canList ? '返回反馈列表' : '返回首页'}
          </button>
        </motion.section>
      </main>
    </>
  );
}
